import React from "react";
import SEO from "../components/SEO";
import { PageHero, SectionHeading, FeatureCard, CTABand, CheckList } from "../components/ui-blocks";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { hospitals, images } from "../mock/mock";

export default function Hospitals() {
  return (
    <>
      <SEO
        title="HIPAA-Compliant Healthcare Call Center & Hospital Answering Service"
        description="24/7 HIPAA-compliant live answering, messaging and medical practice support for hospitals and clinics. Expert agents, customizable solutions and full call-management visibility."
        path="/for-hospitals-clinics"
      />
      <PageHero eyebrow={hospitals.hero.eyebrow} title={hospitals.hero.title} subtitle={hospitals.hero.subtitle} image={images[hospitals.hero.image]}>
        <div className="mt-8">
          <Button asChild size="lg" className="bg-brand-600 hover:bg-brand-700"><Link to="/contact-us">Contact Us <ArrowRight className="ml-1 h-4 w-4" /></Link></Button>
        </div>
      </PageHero>

      <section className="container-x py-16 sm:py-20">
        <SectionHeading center eyebrow="Welcome to the VerifiAssist call center" title="Support your patients trust — around the clock" subtitle="From after-hours coverage for a single department to a complete solution for your entire facility." />
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {hospitals.features.map((f) => <FeatureCard key={f.title} icon={f.icon} title={f.title} body={f.body} />)}
        </div>
      </section>

      <section className="bg-brand-navy">
        <div className="container-x py-16 sm:py-20">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <div>
              <SectionHeading light eyebrow="What to expect" title={hospitals.expect.title} />
              <div className="mt-6"><CheckList items={hospitals.expect.items} light /></div>
            </div>
            <div className="overflow-hidden rounded-3xl border border-white/10 shadow-2xl">
              <img src={images.hospitalTeam} alt="Hospital care team collaborating" className="h-[420px] w-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="container-x py-16 sm:py-20">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div className="overflow-hidden rounded-3xl shadow-xl">
            <img src={images.dentalReception} alt="Medical receptionist providing patient support" className="h-[380px] w-full object-cover" />
          </div>
          <div>
            <SectionHeading eyebrow="Our technology & team" title={hospitals.detail.title} />
            <p className="mt-5 text-slate-600 leading-relaxed">{hospitals.detail.body}</p>
            <div className="mt-6 grid grid-cols-3 gap-4">
              <div className="rounded-xl border border-slate-200 bg-white p-4 text-center shadow-sm"><div className="text-xl font-bold text-brand-600">24/7</div><div className="text-xs text-slate-500">Availability</div></div>
              <div className="rounded-xl border border-slate-200 bg-white p-4 text-center shadow-sm"><div className="text-xl font-bold text-brand-600">100%</div><div className="text-xs text-slate-500">HIPAA compliant</div></div>
              <div className="rounded-xl border border-slate-200 bg-white p-4 text-center shadow-sm"><div className="text-xl font-bold text-brand-600">Multi</div><div className="text-xs text-slate-500">Lingual support</div></div>
            </div>
          </div>
        </div>
      </section>

      <CTABand title="Never miss another important call" body="Contact us today about fully customizable answering service and call center solutions for hospitals and clinics." primaryLabel="Get a Quote" secondaryTo="/insurance-verification" secondaryLabel="Insurance verification" />
    </>
  );
}
